import type { FC } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Checkbox } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindAppsRatingFilter from "../../../../../models/RatingFilter/RatingFilter";
import { StyledFilterHeading } from "../../styles";

import { StyledStarIcon } from "./styles";

export const Score: FC<IFilterViewBaseProps<FindAppsRatingFilter>> = ({ onFilterUpdate, value, filter }) => {
    const { translate } = useTranslate();

    const handleItemSelect = (item: number, selected: boolean) => {
        if (selected) {
            onFilterUpdate({ ...value, score: [...(value?.score ?? []), item] });
            return;
        }

        onFilterUpdate({ ...value, score: value?.score?.filter((v) => v !== item) });
    };

    const renderStars = (score: number) =>
        Array.from({ length: filter.scoreOptions.length - 1 }, (_, index) => (
            <StyledStarIcon
                key={index}
                iconName="star"
                size="xs"
                color={index + 1 <= score ? colorsPalettes.solutions.SALES : colorsPalettes.midnight[100]}
            ></StyledStarIcon>
        ));

    const renderItems = () =>
        filter.scoreOptions.map((option) => {
            const isSelected = Boolean(value?.score?.includes(option));
            return (
                <Flex
                    key={option}
                    gap="8px"
                    alignItems="center"
                >
                    <Checkbox
                        onClick={() => handleItemSelect(option, !isSelected)}
                        selected={isSelected}
                    />
                    <Flex gap="4px">
                        {option === 0 ? (
                            <Text
                                fontVariant="body2"
                                color={colorsPalettes.carbon[500]}
                            >
                                {translate("si.find_apps.filters.rating.select_rating.not_rated")}
                            </Text>
                        ) : (
                            renderStars(option)
                        )}
                    </Flex>
                </Flex>
            );
        });

    return (
        <>
            <StyledFilterHeading>{translate("si.find_apps.filters.rating.select_rating.heading")}</StyledFilterHeading>
            <Stack gap="8px">{renderItems()}</Stack>
        </>
    );
};
